'use client';

export const SetAppHeight = () => {
   return null;
};
